import { queryUserList, addUser, updateUser, deleteUser, resetPassword, updateUserLoginPwd } from "../../api/config/modules/userManagement";

const state = {
  queryUserList: {},
  addUser: {},
  updateUser: {},
  deleteUser: {},
  resetPassword: {},
  updateUserLoginPwd: {}
};

const mutations = {
  SET_QUERYUSERLIST: (state, queryUserList) => {
    state.queryUserList = queryUserList;
  },
  SET_ADDUSER: (state, addUser) => {
    state.addUser = addUser;
  },
  SET_UPDATEUSER: (state, updateUser) => {
    state.updateUser = updateUser;
  },
  SET_DELETEUSER: (state, deleteUser) => {
    state.deleteUser = deleteUser;
  },
  SET_RESETPASSWORD: (state, resetPassword) => {
    state.resetPassword = resetPassword;
  },
  SET_UPDATEUSERLOGINPWD: (state, updateUserLoginPwd) => {
    state.updateUserLoginPwd = updateUserLoginPwd;
  },
};

const actions = {
  GET_QUERYUSERLIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      queryUserList(data)
        .then((res) => {
          commit("SET_QUERYUSERLIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_ADDUSER: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      addUser(data)
        .then((res) => {
          commit("SET_ADDUSER", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPDATEUSER: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      updateUser(data)
        .then((res) => {
          commit("SET_UPDATEUSER", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DELETEUSER: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      deleteUser(data)
        .then((res) => {
          commit("SET_DELETEUSER", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_RESETPASSWORD: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      resetPassword(data)
        .then((res) => {
          commit("SET_RESETPASSWORD", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPDATEUSERLOGINPWD: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      updateUserLoginPwd(data)
        .then((res) => {
          commit("SET_UPDATEUSERLOGINPWD", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
